$(document).ready(function () {
  // blog slider
  function blog_slider() {
    var swiper = new Swiper(".main_blog_sec .blog_post_slider", {
      slidesPerView: 1,
      draggable: true,
      loop: false,
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
      navigation: {
        nextEl: ".sb_arrow_next",
        prevEl: ".sb_arrow_prev",
      },
      breakpoints: {
        1170: {
          slidesPerView: 2,
        }
      },
    });
  }
  blog_slider();
});
function related_categories() {
  var swiper2 = new Swiper(".related_categories .r_categories_wpr", {
    slidesPerView: 1,
    draggable: true,
    loop: false,
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    navigation: {
      nextEl: ".sb_arrow_next",
      prevEl: ".sb_arrow_prev",
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
      },
      640: {
        slidesPerView: 2,
      },
    },
  });
}
related_categories();